import { BIModel } from './BIModel';

export class OfferResponseBIModel extends BIModel {

    static eventName = 'offer_response';

    #productId;
    #offerId;
    #response;
    #message;
    #buyerId;
    #countrySeller;

    constructor(userId, productId, offerId, response, message, buyerId, countrySeller) {
        super(OfferResponseBIModel.eventName, userId);

        this.#productId = productId;
        this.#offerId = offerId;
        this.#response = response;
        this.#message = message;
        this.#buyerId = buyerId;
        this.#countrySeller = countrySeller;
    }

    static createFromDomainEvent(userId, offerCreatedEvent) {
        return new OfferResponseBIModel(
            userId,
            offerCreatedEvent.productId,
            offerCreatedEvent.offerId,
            offerCreatedEvent.response,
            offerCreatedEvent.message,
            offerCreatedEvent.buyerId,
            offerCreatedEvent.countrySeller
        );
    }

    get productId() {
        return this.#productId;
    }

    get offerId() {
        return this.#offerId;
    }

    get response() {
        return this.#response;
    }

    get message() {
        return this.#message;
    }

    get buyerId() {
        return this.#buyerId;
    }

    get countrySeller() {
        return this.#countrySeller;
    }

    get modelData() {
        return {
            product_id: this.productId,
            offer_id: this.offerId,
            response: this.response,
            message: this.message,
            buyer_id: this.buyerId,
            country_seller: this.countrySeller
        };
    }

}